<template>
    <div>
        <h3 class="ta-center">资料模糊</h3>
        <div class="jd-cell cl-desc">请对应视频或图片右上角的数字编号，点击选择有问题的视频或者图片编号。</div>
        <k-cell-group>
            <k-cell v-if="files && files.length">
                视频问题：
                <span v-for="(item,index) in files" :key="index" class="k-checkbox--button">
                    <input v-model="vNums" type="checkbox" name="video"  :value="index+1" class="k-checkbox--button" :id="'video-'+index"><label :for="'video-'+index">视频{{index+1}}</label>
                </span>
            </k-cell>
            <k-cell v-if="pictures && pictures.length">
                图片问题：
                <span v-for="(item,index) in pictures" :key="index" class="k-checkbox--button">
                    <input v-model="pNums" type="checkbox" name="img"  :value="index+1"  class="k-checkbox--button" :id="'img-'+index"><label :for="'img-'+index">图{{index+1}}</label>
                </span>
            </k-cell>
            <k-field
                v-model="reason"
                type="textarea"
                placeholder="需要买家补充资料或者其他问题，请在这里描述···"
                rows="3"
                autosize
                maxLength="100"
            />
            <k-cell>
                <k-button type="primary" block :disabled="!isOk" @click="reply">回复买家</k-button>
            </k-cell>
        </k-cell-group>
    </div>
</template>

<script>
    import {mapActions} from "vuex"
    import {trim} from "../../../utils/xp.v1"
    export default {
        name: "order-redo",
        props: ["files", "pictures", "orderId"],
        data() {
            return {
                id : this.$route.query.orderId,
                vNums : [],
                pNums : [],
                reason : '',
                isOk : false,
                other : []
            }
        },
        methods : {
            ...mapActions("jianding", ["orderStop"]),
            async reply(){
                let {
                    id,
                    vNums,
                    pNums,
                    reason
                } = this;
                let query = {id, vNums,pNums,reason};
                await this.orderStop({
                    vNums : vNums.join(","),
                    pNums : pNums.join(","),
                    id,
                    reason
                }).then(R => {
                    this.$toast.success("操作成功");
                    this.$emit("success", {});
                    location.reload();
                }).catch(err => {
                    this.$toast.fail(err.message);
                })

                console.log(JSON.stringify(query, null, 2))
            }
        },
        watch : {
            reason(nv){
                this.reason = trim(nv);
                if(trim(nv)) {
                    this.isOk = true
                } else {
                    this.isOk = false
                }
            }
        }
    }
</script>

<style scoped>

</style>